import React from 'react';
export const CheckBox = ({ checked, errorMessage, handleChange, label, }) => {
    let componentId;
    if (globalThis.crypto && globalThis.crypto.randomUUID) {
        componentId = globalThis.crypto.randomUUID();
    }
    else {
        componentId =
            Date.now().toString(16).slice(2) + Math.random().toString(16).slice(2);
    }
    return (React.createElement("div", null,
        React.createElement("div", { className: "flex flex-row" },
            React.createElement("div", { className: "mr-2" },
                React.createElement("input", { id: componentId, name: "cookie_consent", type: "checkbox", className: "border border-light-blue-bg rounded-sm", checked: checked, onChange: e => handleChange(e.target.checked) })),
            React.createElement("div", null,
                React.createElement("label", { htmlFor: componentId, className: "text-base font-medium" }, label))),
        errorMessage && (React.createElement("div", { className: "mt-2 text-red text-sm" }, errorMessage))));
};
